export default {
    manufacturer_main_title: "Fabricantes",
    manufacturer_main_id: "Id",
    manufacturer_main_name: "Nombre",
    manufacturer_main_add_manufacturer: "Agregar fabricante",
    manufacturer_main_firmware: "Firmware",
    manufacturer_main_manufacturer: "Fabricante",
    manufacturer_main_configuration: "Configuración por Defecto",
    manufacturer_main_canned_commands: "Comandos",
    manufacturer_main_status: "Estado",
    manufacturer_main_created_on: "Creado en",
    manufacturer_main_sync_ctc_information: "Sincronizar información del CTC",
}